import {lshGETAUTH, FILE_API} from './core';
import {graphqlRequestHandler} from './core';
import {
  IDeliveryCost,
  IDeliveryLocationInput,
  IDeliveryProductInput,
  IGenericType,
  ILayerHistoryResponse,
  ILayerResponse,
  IPolygonData,
  IPolygonInput,
} from 'constants/interfaces';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const apiGetNDVI = async (
  startDate: string,
  endDate: string,
  polygons?: IPolygonData[],
): Promise<ILayerResponse[]> => {
  return lshGETAUTH().then((data) => {
    const headers = {
      Authorization: data,
    };
    const query = `
    query variables ($polygons: [PolygonInput!]!, $startDate: String!, $endDate: String!) {
      getNDVI(polygons: $polygons, endDate: $endDate, startDate: $startDate) {
        url
        error

      }
    }
  `;
    const variables = {startDate, endDate, polygons};
    return new Promise(async (resolve, reject) => {
      graphqlRequestHandler('getNDVI', query, variables, headers)
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
};

export const apiFieldLayers = async (
  startDate: string,
  endDate: string,
  polygons?: IPolygonData[],
): Promise<ILayerResponse[][]> => {
  return lshGETAUTH().then((data) => {
    const headers = {
      Authorization: data,
    };
    const query = `
    query variables ($polygons: [PolygonInput!]!, $startDate: String!, $endDate: String!) {
      getFieldLayers(polygons: $polygons, endDate: $endDate, startDate: $startDate) {
        url
        error
         riskLevel
        layer
      }
    }
  `;
    const variables = {startDate, endDate, polygons};
    return new Promise(async (resolve, reject) => {
      graphqlRequestHandler('getFieldLayers', query, variables, headers)
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
};

export const apiFieldLayersByIds = async (
  fieldIds: Array<string | number>,
  analysisDate: string,
): Promise<ILayerHistoryResponse[]> => {
  return lshGETAUTH().then((data) => {
    const headers = {
      Authorization: data,
    };
    const query = `
    query variables($fieldIds: [ID!]!, $analysisDate: String!) {
      getFieldLayersByIDs(fieldIds: $fieldIds, analysisDate: $analysisDate) {
        fieldId
        analysisDate
        layers {
          url
          error
          riskLevel
          layer
        }
      }
    }
  `;
    const variables = {fieldIds, analysisDate};
    return new Promise(async (resolve, reject) => {
      graphqlRequestHandler('getFieldLayersByIDs', query, variables, headers)
        .then((res) => resolve((res as ILayerHistoryResponse[]) || []))
        .catch((error) => reject(error));
    });
  });
};

export async function apiSavePolygons(
  polygons: IPolygonInput,
  farmId: number,
): Promise<IGenericType> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {polygons, farmId};
    return new Promise((resolve, reject) => {
      const query = `
          mutation variables($farmId:ID!,$polygons:[PolygonInput]) {
            saveFarmPolygonSupplier(
             farmId:$farmId,polygons:$polygons
            ) {
              success
              message
            }
          }`;
      graphqlRequestHandler(
        'saveFarmPolygonSupplier',
        query,
        variables,
        headers,
      )
        .then((response: IGenericType) => resolve(response))
        .catch((error) => reject(error));
    });
  });
}

export async function apiUpdateFarmField(
  fieldId: string | number,
  field: IPolygonInput,
): Promise<IGenericType> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {fieldId, field};
    return new Promise((resolve, reject) => {
      const query = `
          mutation UpdateFarmField($fieldId: ID!, $field: PolygonInput) {
            updateFarmField(fieldId: $fieldId, field: $field) {
              success
              message
            }
          }`;
      graphqlRequestHandler(`updateFarmField`, query, variables, headers)
        .then((response: IGenericType) => resolve(response))
        .catch((error) => reject(error));
    });
  });
}

export async function apiDeleteFarmField(
  fieldId: string | number,
): Promise<IGenericType> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {fieldId};
    return new Promise((resolve, reject) => {
      const query = `
          mutation DeleteFarmField($fieldId: ID!) {
            deleteFarmField(fieldId: $fieldId) {
              success
              message
            }
          }`;
      graphqlRequestHandler(`deleteFarmField`, query, variables, headers)
        .then((response: IGenericType) => resolve(response))
        .catch((error) => reject(error));
    });
  });
}

export async function apiCalculateDeliveryCost(
  startLocation: IDeliveryLocationInput,
  endLocation: IDeliveryLocationInput,
  products: IDeliveryProductInput[],
): Promise<IDeliveryCost> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {startLocation, endLocation, products};
    return new Promise((resolve, reject) => {
      const query = `
          query variables(
            $startLocation: DeliveryLocationInput!,
            $endLocation: DeliveryLocationInput!,
            $products: [DeliveryProductInput!]!
          ){
            calculateDeliveryCost(
              startLocation: $startLocation,
              endLocation: $endLocation,
              products: $products,
            ){
              success
              message
              totalDeliveryCost
              originalTotalDeliveryCost
            }
          }`;
      graphqlRequestHandler('calculateDeliveryCost', query, variables, headers)
        .then((response: IDeliveryCost) => resolve(response))
        .catch((error) => reject(error));
    });
  });
}

export async function apiUploadFile(
  file: File,
  fileKey: string,
  bucket: string = 'khula-farmer-profile-documents',
): Promise<string> {
  const form = new FormData();
  form.append('bucket', bucket);
  form.append('fileKey', fileKey);
  form.append('file', file);

  return fetch(FILE_API, {
    headers: {
      Authorization: await lshGETAUTH(),
      platform: 'WEB_SUPPLIER',
      requestSourceUserType: 'supplier',
    },
    method: 'POST',
    body: form,
  })
    .then((res) => res.json())
    .then((res) => res.url);
}
